import { render, staticRenderFns } from "./appAssetPage.vue?vue&type=template&id=18520d3f&scoped=true"
import script from "./appAssetPage.vue?vue&type=script&lang=js"
export * from "./appAssetPage.vue?vue&type=script&lang=js"
import style0 from "./appAssetPage.vue?vue&type=style&index=0&id=18520d3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18520d3f",
  null
  
)

export default component.exports